import { assertNever } from '@kofno/piper';
import { array } from 'jsonous';
import { just, Maybe, nothing } from 'maybeasy';
import { getFieldValue } from '../../../../../../FormFields';
import ReactionComponent, { RCProps } from '../../../../../../ReactionComponent';
import { FormFieldOutputValue, FieldValue } from '../../../../Types';
import CoachSelectStore from '../Store';
import { State } from '../Store/Types';
import { formFieldValueDecoder } from '../../../../Decoders';

interface Props extends RCProps<CoachSelectStore> {}

const validateValue = (value: FormFieldOutputValue): Maybe<FieldValue[]> =>
  array(formFieldValueDecoder).decodeAny(value).map(just).getOrElse(nothing);

class CoachSelectReactions extends ReactionComponent<CoachSelectStore, State, Props> {
  tester = () => this.props.store.state;

  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'initializing':
        state.segmentStore.addEmbeddedFormFieldOutput(store);
        getFieldValue(state.segmentStore.results, store.id)
          .andThen(validateValue)
          .do((value) => store.ready(state.formField, value))
          .elseDo(() => store.ready(state.formField, []));
        break;
      case 'waiting':
      case 'ready':
      case 'auto-saving':
        break;
      default:
        assertNever(state);
    }
  };
}

export default CoachSelectReactions;
